document.addEventListener('load',modifyAccordion());

function modifyAccordion() {
  let stamped = document.querySelector('.stamped-product-reviews-badge');
  let stampedClone = stamped.cloneNode(true);
  
  let reviewAccordionChild = document.querySelector('.cc-accordion-item #stamped-main-widget');
  let reviewAccordion = reviewAccordionChild ? reviewAccordionChild.closest('.cc-accordion-item') : null;
  
  if (reviewAccordion) {
    reviewAccordion.querySelector('.cc-accordion-item__title').append(stampedClone);
    let reviewBtn = document.createElement('span');
    reviewAccordion.querySelector('.cc-accordion-item__title').append(reviewBtn);
    reviewBtn.outerHTML = `<span class=\"stamped-summary-actions-newreview\" role=\"button\" onclick=\"StampedFn.toggleForm('review','${productId}');return false;\" onkeydown=\"StampedFn.toggleForm('review','${productId}');return false;\" style=\"cursor: pointer;\" tabindex=\"0\" aria-controls=\"new-review-form_${productId}\">Write a Review</span>`;
  }

  let qaTitle = document.querySelector('.product-questions .cc-accordion-item__title');
  if (!qaTitle) return;
  let questionCount = document.createElement('span');
  questionCount.innerText = `${qaCount} question${qaCount > 1 ? 's' : ''}`;
  questionCount.className = 'question-count';

  qaTitle.append(questionCount);

}